import { render, staticRenderFns } from "./EvaluationPage.vue?vue&type=template&id=5eaf8b52&"
import script from "./EvaluationPage.vue?vue&type=script&lang=js&"
export * from "./EvaluationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports